import { SpeedInsights } from '@vercel/speed-insights/next';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { SWRConfig } from 'swr';
import { GLOBAL_ALERT } from '../config/featureToggles/constants';
import { isEnabled } from '../config/featureToggles/utils';
import { OtovoConfigContext } from '../hooks/configContext';
import { setLocale } from '../lib/dayjs';
import { Otovo$Config, Otovo$Locale } from '../types/otovoweb';
import LanguageProvider from './LanguageProvider';

const GlobalAlert = dynamic(() => import('./GlobalAlert/GlobalAlert'));

type NextPageRootProps = {
  children: React.ReactNode;
  configValues: Otovo$Config;
};

const NextPageRoot = ({ children, configValues }: NextPageRootProps) => {
  const { locale } = useRouter() as { locale: Otovo$Locale };
  const {
    BU_CONFIG: { locale: defaultLocale },
  } = configValues;

  useEffect(() => {
    // Set the locale for date formatting. Applies for client side rendered
    // parts of the page.
    setLocale((locale as string) !== 'default' ? locale : defaultLocale);
  }, [locale, defaultLocale]);

  return (
    <OtovoConfigContext.Provider value={configValues}>
      <LanguageProvider config={configValues}>
        <>
          <SWRConfig
            value={{
              provider: () => new Map(),
            }}
          >
            {isEnabled(GLOBAL_ALERT, configValues) && <GlobalAlert />}
            {children}
          </SWRConfig>
        </>
      </LanguageProvider>
      {/* The speed insights library break in tests See */}
      {/* https://github.com/vercel/speed-insights/issues/56 for more information. */}
      {!!process.env.NEXT_PUBLIC_VERCEL_ENV && (
        <SpeedInsights sampleRate={0.05} />
      )}
    </OtovoConfigContext.Provider>
  );
};

export default NextPageRoot;
